var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var Help16 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '16px' : _c, _d = _a.width, width = _d === void 0 ? '16px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 16 16", style: svgStyle },
            React.createElement("g", { fillRule: "evenodd" },
                React.createElement("path", { d: "M8 15c3.867 0 7-3.133 7-7a7 7 0 10-7 7zm0-.75a6.25 6.25 0 110-12.5 6.25 6.25 0 010 12.5z", fillRule: "nonzero" }),
                React.createElement("path", { d: "M6.378 6.163v-.019a1.766 1.766 0 01.177-.875c.278-.558.856-.894 1.892-.894 1.663 0 2.295 1.452 1.547 2.13a3.695 3.695 0 01-.424.328 7.25 7.25 0 01-.29.184l-.297.179c-1.044.63-1.456 1.215-1.456 2.519h.75c0-1.008.256-1.37 1.094-1.878l.298-.179c.122-.073.222-.137.32-.202.187-.127.353-.254.509-.395 1.272-1.153.278-3.436-2.051-3.436-1.313 0-2.155.49-2.563 1.31a2.48 2.48 0 00-.255 1.254l.004.056.745-.082z", fillRule: "nonzero" }),
                React.createElement("path", { d: "M8.509 11.398a.63.63 0 11-1.258.002.63.63 0 011.258-.002" })))));
};
Help16.displayName = 'Help16';
export default Help16;
//# sourceMappingURL=help-16.js.map